// Bilingual strings (Finnish / English) — production-grade enterprise SaaS terminology
export const translations = {
  fi: {
    appName: "TALKTO+",
    appSub: "Enterprise",
    appTagline: "Toimeenpanoriskien validointimoottori",
    liveLabel: "Live",
    fourEyes: "4-Silmän Periaate",
    version: "",
    demoBanner: "DEMO MODE — 100% SOVEREIGN INTELLIGENCE",
    search: "Rajaa nykyista näkymää...",
    signOut: "Kirjaudu ulos",
    allBusinessUnits: "Kaikki yksiköt",
    export: "Vie",
    view: "Näytä",
    viewAll: "Näytä kaikki",
    viewAllBottlenecks: "Näytä kaikki pullonkaulat",
    viewSystemHealth: "Näytä järjestelmän tila",
    loading: "Ladataan…",
    empty: "Ei dataa",
    cancel: "Peruuta",
    save: "Tallenna",
    close: "Sulje",
    days7: "7 päivää",
    days14: "14 päivää",
    days30: "30 päivää",
    nav: {
      boardroom: "Johtokunnan näkymä",
      boardroomSub: "Ylätason yhteenveto",
      signals: "Signaalitutka",
      signalsSub: "Reaaliaikainen äly",
      decision: "Päätöskeskus",
      decisionSub: "Riskien validointi",
      global: "Riski ja valmius",
      globalSub: "Validoidut mallit",
      actions: "Toimintakortit",
      actionsSub: "Preskriptiiviset pelikirjat",
      rag: "Strategia-RAG",
      ragSub: "Tietopohja",
      ingestion: "Datan tuonti",
      ingestionSub: "Batch-tarkistus",
      tenants: "Organisaatiot",
      tenantsSub: "Tenant-hallinta",
      workspace: "Työtila",
      workspaceSub: "Workflow-työskentely",
      enterprise: "Enterprise Control Plane",
      enterpriseSub: "Admin console",
      system: "Järjestelmän tila",
      systemSub: "Infrastruktuuri",
      audit: "Audit Trail",
      auditSub: "Trust trace",
      notifications: "Hälytykset",
      notificationsSub: "Operational notices",
    },
    boardroom: {
      title: "Johtokunnan näkymä",
      subtitle: "Toimeenpanoriskien validointimoottori",
      heatmap: "Suvereeniteettianalyysi — lämpökartta",
      heatmapSub: "Reaaliaikainen toimeenpanoriski organisaatiossasi",
      resources: "Resurssit",
      capabilities: "Osaaminen",
      engagement: "Sitoutuminen",
      process: "Prosessit",
      boardReport: "Vie hallitusraportti PDF",
      boardReportReady: "Hallitusraportti valmis ✓",
      exporting: "Luodaan…",
      trend: "Globaali Riski-indeksi — trendi",
      trendSub: "Eksponentiaalisesti aikavaimennettu toimeenpanoriski",
      distribution: "Riskijakauma",
      distributionSub: "Vakavuustasoittain",
      total: "Riskit yhteensä",
      earlyWarnings: "Early warnings not enabled",
      earlyWarningsSub: "Future advisory module outside this demo",
      universal: "Universaalit pullonkaulat",
      universalSub: "Yleisimmät toimeenpano-aukot globaalisti",
      recent: "Viimeisimmät validoidut signaalit",
      recentSub: "AI-analysoidut ja ihmisen validoimat oivallukset",
      systemStatus: "Järjestelmän tila",
      systemStatusSub: "Kaikki järjestelmät toiminnassa",
      localAI: "Paikallinen tekoäly",
      database: "Tietokanta",
      vectorDB: "Vektoritietokanta",
      mothership: "Sisainen mallirekisteri",
      online: "Online",
      healthy: "Terve",
      connected: "Yhdistetty",
      velocity: "Nopeus",
      zscore: "Z-pistemäärä",
      confidence: "Luottamus",
      riskScore: "Riski-pisteet",
      stable: "VAKAA",
      rising: "NOUSEVA",
      falling: "LASKEVA",
    },
    decision: {
      title: "Päätöskeskus",
      subtitle: "4-Silmän periaate — tekoäly ehdottaa, asiantuntija päättää",
      pending: "Odottaa validointia",
      noPending: "Ei odottavia signaaleja — hienoa työtä!",
      signal: "Signaali",
      aiAnalysis: "Tekoälyanalyysi",
      gaps: "Toimeenpano-aukot",
      assumptions: "Piilo-oletukset",
      questions: "Kysymykset fasilitaattorille",
      riskLevel: "Riskitaso",
      validate: "Vahvista",
      override: "Muuta tasoa",
      dismiss: "Hylkää",
      escalate: "Eskaloi",
      inProgress: "Käynnistä",
      note: "Muistiinpano (valinnainen)",
      overrideTo: "Muuta riskitasoksi",
      submit: "Lähetä päätös",
    },
    signals: {
      title: "Signaalitutka",
      subtitle: "Kaikki organisaation signaalit",
      filterAll: "Kaikki",
      filterPending: "Odottaa",
      filterValidated: "Validoitu",
      filterDismissed: "Hylätty",
      newSignal: "Uusi signaali",
      content: "Sisältö",
      businessUnit: "Yksikkö",
      submit: "Lähetä analyysiin",
    },
    global: {
      title: "Riski ja valmius",
      subtitle: "Validoidut toimeenpanomallit ilman ulkoista datanjakoa",
      clusters: "Pullonkaulaklusterit",
      fragments: "Validoidut fragmentit",
      sectors: "Sektorit",
      sectorsAffected: "Sektoreita mukana",
      recompute: "Päivitä kooste",
    },
    actions: {
      title: "Toimintakortit",
      subtitle: "Preskriptiiviset pelikirjat — Hybrid RAG",
      playbook: "Pelikirja",
      swarmUsed: "Validoidut mallit käytössä",
      impact: "Vaikuttavuus",
      scoreHint: "Arvioi vaikuttavuus 1-10",
      verified: "Mallivahvistettu",
      verifiedBy: "Vahvistettu {n} samankaltaisessa organisaatiossa",
      status: "Tila",
      pending_validation: "Odottaa validointia",
      validated: "Vahvistettu",
      in_progress: "Käynnissä",
      started: "Käynnistetty",
      blocked: "Estynyt",
      completed: "Valmis",
      dismissed: "Hylätty",
      escalated: "Eskaloitu",
      outcome: "Lopputulos",
      unknown: "Tuntematon",
      resolved: "Ratkaistu",
      partially_resolved: "Osittain ratkaistu",
      not_useful: "Ei hyodyllinen",
      facilitator: "Fasilitaattori",
      validate: "Vahvista",
      dismiss: "Hylkää",
      escalate: "Eskaloi",
      start: "Käynnistä",
      block: "Esta",
      complete: "Valmis",
      pdf: "PDF",
    },
    rag: {
      title: "Strategia-RAG",
      subtitle: "Tietopohja — semanttinen haku",
      title2: "Dokumentin otsikko",
      content: "Dokumentin sisältö",
      add: "Lisää dokumentti",
      empty: "Ei strategia-dokumentteja — lisää ensimmäinen.",
      chunks: "osaa",
    },
    tenants: {
      title: "Organisaatiot",
      subtitle: "Multi-tenant -hallinta",
      name: "Nimi",
      sector: "Sektori",
      description: "Kuvaus",
      add: "Lisää organisaatio",
      sectorHash: "Sektorin hash",
      active: "Aktiivinen",
    },
    system: {
      title: "Järjestelmän tila",
      subtitle: "Infrastruktuurin reaaliaikainen seuranta",
      service: "Palvelu",
      status: "Tila",
      details: "Yksityiskohdat",
      overall: "Yleistila",
      operational: "Toiminnassa",
      degraded: "Alentunut",
    },
    audit: {
      title: "Audit-loki",
      subtitle: "Sanitoitu jaljitettavyys",
      timestamp: "Aika",
      actor: "Toimija",
      eventType: "Tapahtuma",
      entity: "Kohde",
      status: "Tila",
      metadata: "Metadata",
      refresh: "Paivita",
      previous: "Edellinen",
      next: "Seuraava",
    },
    auth: {
      title: "TALKTO+ Enterprise",
      subtitle: "Execution Intelligence",
      login: "Kirjaudu",
      register: "Rekisteröidy",
      email: "Sähköposti",
      password: "Salasana",
      fullName: "Nimi",
      haveAccount: "Onko sinulla jo tili?",
      noAccount: "Eikö sinulla ole tiliä?",
      demoHint: "Demo access is protected. Use the credentials provided by the demo owner.",
      signIn: "Kirjaudu sisään",
      signUp: "Luo tili",
    },
    profile: {
      title: "Käyttäjäprofiili",
      role: "Rooli",
      organization: "Organisaatio",
      switchRole: "Vaihda demo-rooli",
      facilitator: "Fasilitaattori",
      participant: "Participant",
      executive: "Johto (C-taso)",
      admin: "Pääkäyttäjä",
      super_admin: "Pääkäyttäjä",
      viewer: "Katselija",
      notifications: "Hälytysasetukset",
      saved: "Profiili tallennettu",
      switchedTo: "Näkymä vaihdettu: {role}",
    },
    notif: {
      title: "Hälytykset",
      subtitle: "Operational notification endpoints",
      addChannel: "Lisää kanava",
      type: "Tyyppi",
      minSev: "Vähimmäisvakavuus",
      label: "Otsikko",
      url: "Webhook-osoite",
      test: "Testaa",
      tested: "Testihälytys lähetetty",
      empty: "Ei kanavia. Lisää ensimmäinen yllä.",
    },
  },
  en: {
    appName: "TALKTO+",
    appSub: "Enterprise",
    appTagline: "Execution Risk Validation Engine",
    liveLabel: "Live",
    fourEyes: "Four-Eyes Mode",
    version: "",
    demoBanner: "DEMO MODE",
    search: "Filter current view...",
    signOut: "Sign out",
    allBusinessUnits: "All Business Units",
    export: "Export",
    view: "View",
    viewAll: "View All",
    viewAllBottlenecks: "View All Bottlenecks",
    viewSystemHealth: "View System Health",
    loading: "Loading…",
    empty: "No data",
    cancel: "Cancel",
    save: "Save",
    close: "Close",
    days7: "7 days",
    days14: "14 days",
    days30: "30 days",
    nav: {
      boardroom: "Boardroom",
      boardroomSub: "Executive brief",
      signals: "Signals",
      signalsSub: "Human validation",
      decision: "Decision Hub",
      decisionSub: "Risk Validation",
      global: "Risk & Readiness",
      globalSub: "Validated patterns",
      actions: "Action Plan",
      actionsSub: "Validated next steps",
      rag: "Strategy RAG",
      ragSub: "Knowledge Base",
      ingestion: "Ingestion",
      ingestionSub: "Batch review",
      tenants: "Tenants",
      tenantsSub: "Organization Mgmt",
      workspace: "Workflow Workspace",
      workspaceSub: "Stage tasks",
      enterprise: "Enterprise Control Plane",
      enterpriseSub: "Admin console",
      system: "System Status",
      systemSub: "Runtime checks",
      audit: "Audit Trail",
      auditSub: "Trust trace",
      notifications: "Notifications",
      notificationsSub: "Operational notices",
    },
    boardroom: {
      title: "Boardroom View",
      subtitle: "What leadership needs to know now",
      heatmap: "Execution Risk Heatmap",
      heatmapSub: "Real-time execution risk across your organization",
      resources: "Resources",
      capabilities: "Capabilities",
      engagement: "Engagement",
      process: "Process",
      boardReport: "Export Board Report PDF",
      boardReportReady: "Board report ready ✓",
      exporting: "Generating…",
      trend: "Global Risk Index Trend",
      trendSub: "Exponentially decay-adjusted execution risk",
      distribution: "Risk Distribution",
      distributionSub: "By severity level",
      total: "Total Risks",
      earlyWarnings: "Early warnings not enabled",
      earlyWarningsSub: "Future advisory module outside this demo",
      universal: "Universal Bottlenecks",
      universalSub: "Most common execution gaps globally",
      recent: "Recent Validated Signals",
      recentSub: "AI-analyzed and human-validated insights",
      systemStatus: "System Status",
      systemStatusSub: "All systems operational",
      localAI: "Local AI",
      database: "Database",
      vectorDB: "Vector DB",
      mothership: "Internal pattern registry",
      online: "Online",
      healthy: "Healthy",
      connected: "Connected",
      velocity: "Velocity",
      zscore: "Z-Score",
      confidence: "Confidence",
      riskScore: "Risk Score",
      stable: "STABLE",
      rising: "RISING",
      falling: "FALLING",
    },
    decision: {
      title: "Decision Hub",
      subtitle: "Four-Eyes Principle — AI proposes, human decides",
      pending: "Pending validation",
      noPending: "No pending signals — great work!",
      signal: "Signal",
      aiAnalysis: "AI Analysis",
      gaps: "Execution Gaps",
      assumptions: "Hidden Assumptions",
      questions: "Facilitator Questions",
      riskLevel: "Risk Level",
      validate: "Validate",
      override: "Override",
      dismiss: "Dismiss",
      escalate: "Escalate",
      inProgress: "Start",
      note: "Note (optional)",
      overrideTo: "Override risk level to",
      submit: "Submit Decision",
    },
    signals: {
      title: "Signals Radar",
      subtitle: "All organizational signals",
      filterAll: "All",
      filterPending: "Pending",
      filterValidated: "Validated",
      filterDismissed: "Dismissed",
      newSignal: "New signal",
      content: "Content",
      businessUnit: "Business Unit",
      submit: "Submit for analysis",
    },
    global: {
      title: "Risk & Readiness",
      subtitle: "Validated execution patterns with no external data sharing",
      clusters: "Bottleneck clusters",
      fragments: "Validated fragments",
      sectors: "Sectors",
      sectorsAffected: "Sectors affected",
      recompute: "Refresh aggregate",
    },
    actions: {
      title: "Action Cards",
      subtitle: "Prescriptive playbooks — Hybrid RAG",
      playbook: "Playbook",
      swarmUsed: "Validated patterns used",
      impact: "Impact",
      scoreHint: "Score impact 1-10",
      verified: "Pattern verified",
      verifiedBy: "Verified by {n} similar organizations",
      status: "Status",
      pending_validation: "Pending Validation",
      validated: "Validated",
      in_progress: "In Progress",
      started: "Started",
      blocked: "Blocked",
      completed: "Completed",
      dismissed: "Dismissed",
      escalated: "Escalated",
      outcome: "Outcome",
      unknown: "Unknown",
      resolved: "Resolved",
      partially_resolved: "Partially resolved",
      not_useful: "Not useful",
      facilitator: "Facilitator",
      validate: "Validate",
      dismiss: "Dismiss",
      escalate: "Escalate",
      start: "Start",
      block: "Block",
      complete: "Complete",
      pdf: "PDF",
    },
    rag: {
      title: "Strategy RAG",
      subtitle: "Knowledge base — semantic search",
      title2: "Document title",
      content: "Document content",
      add: "Add document",
      empty: "No strategy documents — add the first.",
      chunks: "chunks",
    },
    tenants: {
      title: "Tenants",
      subtitle: "Multi-tenant organization management",
      name: "Name",
      sector: "Sector",
      description: "Description",
      add: "Add tenant",
      sectorHash: "Sector Hash",
      active: "Active",
    },
    system: {
      title: "System Health",
      subtitle: "Real-time infrastructure monitoring",
      service: "Service",
      status: "Status",
      details: "Details",
      overall: "Overall",
      operational: "Operational",
      degraded: "Degraded",
    },
    audit: {
      title: "Audit View",
      subtitle: "Sanitized operational trace",
      timestamp: "Timestamp",
      actor: "Actor",
      eventType: "Event type",
      entity: "Entity",
      status: "Status",
      metadata: "Metadata",
      refresh: "Refresh",
      previous: "Previous",
      next: "Next",
    },
    auth: {
      title: "TALKTO+ Enterprise",
      subtitle: "Execution Intelligence",
      login: "Sign in",
      register: "Register",
      email: "Email",
      password: "Password",
      fullName: "Full name",
      haveAccount: "Already have an account?",
      noAccount: "Don't have an account?",
      demoHint: "Demo access is protected. Use the credentials provided by the demo owner.",
      signIn: "Sign in",
      signUp: "Create account",
    },
    profile: {
      title: "User profile",
      role: "Role",
      organization: "Organization",
      switchRole: "Switch demo role",
      facilitator: "Facilitator",
      participant: "Participant",
      executive: "Executive (C-level)",
      admin: "Administrator",
      super_admin: "Administrator",
      viewer: "Viewer",
      notifications: "Notification preferences",
      saved: "Profile saved",
      switchedTo: "Viewing as {role}",
    },
    notif: {
      title: "Notifications",
      subtitle: "Operational notification endpoints",
      addChannel: "Add channel",
      type: "Type",
      minSev: "Min severity",
      label: "Label",
      url: "Webhook URL",
      test: "Test",
      tested: "Test alert sent",
      empty: "No channels. Add the first one above.",
    },
  },
};

export function useT(locale) {
  return translations[locale] || translations.fi;
}

export function tFmt(s, params) {
  return Object.entries(params || {}).reduce((acc, [k, v]) => acc.replace(`{${k}}`, v), s);
}
